// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__fCE8U","title":"Card_title__1ATmK","year":"Card_year__ATOt7","user":"Card_user__2YseH","toolbar":"Card_toolbar__1kJPi","button":"Card_button__14rTI"};